interface CjsModuleNamespace<TDefault> {
  __esModule?: boolean;
  default: TDefault;
}

const isCjsModuleNamespace = <TDefault>(
  moduleExport: TDefault | CjsModuleNamespace<TDefault>,
): moduleExport is CjsModuleNamespace<TDefault> => {
  return (
    typeof moduleExport === 'object' &&
    moduleExport !== null &&
    'default' in moduleExport
  );
};

export const resolveCjsDefaultExport = <TDefault>(
  moduleExport: TDefault | CjsModuleNamespace<TDefault>,
): TDefault => {
  return isCjsModuleNamespace(moduleExport)
    ? moduleExport.default
    : moduleExport;
};
